import { render, staticRenderFns } from "./douKuaiCell.vue?vue&type=template&id=f865fbfa&scoped=true"
import script from "./douKuaiCell.vue?vue&type=script&lang=js"
export * from "./douKuaiCell.vue?vue&type=script&lang=js"
import style0 from "./douKuaiCell.vue?vue&type=style&index=0&id=f865fbfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f865fbfa",
  null
  
)

export default component.exports